import { types } from "../constants/types";

export const getHolidayData = (data) => ({
    type: types.GET_HOLIDAY_REQUEST,
    payload:data
});
export const getEmployeeProfile = (data) => ({
    type: types.GET_EMPLOYEEPROFILE_REQUEST,
    payload:data
});
export const getReminder = (data) => ({
    type: types.GET_REMINDER_REQUEST,
    payload:data
});
export const getSalary = (data) => ({
    type: types.GET_SALARY_REQUEST,
    payload:data
});
export const getEmployeeLeaveRequest= (data) => ({
    type: types.GET_EMP_LEAVEREQUEST_REQUEST,
    payload:data
});
export const getEmployeeAttendance= (data) => ({
    // type: types.GET_EMP_ATTENDANCE_REQUEST,
    payload:data
});

export const getEmployeeSalaryDetails= (data) => ({
    type: types.GET_EMPSALARYDATA_REQUEST,
    payload:data
});

export const getAllInvoiceData= (data) => ({
    type: types.GET_ALL_INVOICE_REQUEST,
    payload:data
});
export const getAssingAssetsData= (data) => ({
    type: types.GET_ASSIGN_ASSET_REQUEST,
    payload:data
});

export const getCustomerData= (data) => ({
    type: types.GET_CUSTOMER_REQUEST,
    payload:data
});

